import { concat, ReplaySubject } from "rxjs";
import { filter, multicast, take, takeWhile } from "rxjs/operators";
export function takeWhileInclusive(predicate) {
    return (source) => source.pipe(multicast(() => new ReplaySubject(1), (sharedSource) => concat(sharedSource.pipe(takeWhile(predicate)), sharedSource.pipe(take(1), filter((value) => !predicate(value))))));
}
//# sourceMappingURL=takeWhileInclusive.js.map